import React from "react";
import { Box, Skeleton, Alert } from "@mui/material";

const Step2Skeleton = () => {
  return (
    <Box sx={{ width: "100%", marginTop: 2 }}>
      {/* Info Alert Skeleton */}
      <Box sx={{ mb: 2, maxWidth: "600px" }}>
        <Alert severity="info">
          <Skeleton variant="text" width="90%" height={20} />
        </Alert>
      </Box>

      {/* Single Custodian Section */}
      <Box sx={{ width: "100%", maxWidth: "600px" }}>
        {/* Custodian Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: "10px",
            width: "100%",
            mb: 1,
          }}
        >
          <Box>
            <Skeleton variant="text" width={200} height={24} />
            <Skeleton variant="text" width={120} height={20} />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Skeleton variant="text" width={40} height={16} />
            <Skeleton variant="text" width={40} height={16} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
        </Box>

        {/* Table Container */}
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          {/* Table Header */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr",
              gap: 2,
              p: 1.5,
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Skeleton variant="text" width="80%" height={20} />
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="60%" height={20} />
          </Box>

          {/* Table Rows - Only 3 rows like the real data */}
          <Box>
            {Array.from({ length: 3 }).map((_, rowIndex) => (
              <Box
                key={rowIndex}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr",
                  gap: 2,
                  p: 1.5,
                  borderBottom: rowIndex < 2 ? "1px solid #f0f0f0" : "none",
                  backgroundColor: rowIndex % 2 === 0 ? "#fafafa" : "#ffffff",
                }}
              >
                <Skeleton variant="text" width="60%" height={16} />
                <Skeleton variant="text" width="70%" height={16} />
                <Skeleton variant="text" width="70%" height={16} />
                <Skeleton variant="text" width="50%" height={16} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Step2Skeleton; 